import React, { FC } from 'react'
import { Badge, List, Space, Tag, Typography } from 'antd'
import { useQuery } from '@apollo/client'
import { translate } from '../../../core'
import { ItemType } from '../../inventory/type/item'
import { productTypeDisplayLabel } from '../type/filter-catalog'
import {
  GetFilterBaseConfig,
  GetFilterOverridesByType,
} from '../graphql/filter-config.graphql'

interface CounterProps {
  productType: ItemType
}

const SidebarCounters: FC<CounterProps> = ({ productType }) => {
  const { data: baseData } = useQuery(GetFilterBaseConfig, {
    variables: { productType },
    fetchPolicy: 'cache-and-network',
  })
  const { data: overrideData } = useQuery(GetFilterOverridesByType, {
    variables: { productType },
    fetchPolicy: 'cache-and-network',
  })

  const enabledCount =
    baseData?.filterBaseConfig.filter((row) => row.enabled).length ?? 0
  const overrideCount = overrideData?.filterOverridesByType.length ?? 0

  return (
    <Space size={4}>
      <Tag color="blue">{enabledCount} {translate('filter')}</Tag>
      <Tag color={overrideCount > 0 ? 'orange' : 'default'}>
        {overrideCount} {translate('overrides')}
      </Tag>
    </Space>
  )
}

interface Props {
  productTypes: ReadonlyArray<ItemType>
  active: ItemType
  onChange: (next: ItemType) => void
}

export const FilterConfigSidebar: FC<Props> = ({ productTypes, active, onChange }) => {
  return (
    <List
      header={
        <Typography.Text strong style={{ fontSize: 16 }}>
          {translate('product_type')}
        </Typography.Text>
      }
      bordered
      dataSource={[...productTypes]}
      renderItem={(type) => (
        <List.Item
          onClick={() => onChange(type)}
          style={{
            cursor: 'pointer',
            background: type === active ? 'rgba(22, 119, 255, 0.06)' : undefined,
          }}
        >
          <List.Item.Meta
            title={
              <Space>
                <Badge status={type === active ? 'processing' : 'default'} />
                <Typography.Text
                  strong={type === active}
                  style={{ fontSize: 15 }}
                >
                  {productTypeDisplayLabel(type)}
                </Typography.Text>
              </Space>
            }
            description={<SidebarCounters productType={type} />}
          />
        </List.Item>
      )}
    />
  )
}
